import { type NotificationList, type Pagination, createNotificationList } from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getNotifications } from '../services';
import { getNotificationsInfiniteQueryKey } from './keys';

type P = {
  pagination: Omit<Pagination, 'position'>;
};

export const useNotificationsInfiniteQuery = ({ pagination: { pageSize } }: P) =>
  useInfiniteQuery<NotificationList[], string | undefined, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async queryFn({ pageParam: cursor }) {
      const response = await getNotifications({ config: { params: { cursor, limit: pageSize } } });
      return response.data.map((notification) => createNotificationList(notification));
    },
    initialPageParam: undefined,
    getNextPageParam(lastPage) {
      if (lastPage.length < pageSize) {
        return undefined;
      }
      return lastPage.at(-1)?.id;
    },
    queryKey: getNotificationsInfiniteQueryKey({}),
  });
